import QuestionLabel from './QuestionLabel';
import useCurrentBusiness from '~/lib/useCurrentBusiness';
import type { QuestionComponentProps } from '~/lib/Questions/Questions.types';
import { useInvoiceContext } from '~/lib/InvoiceContext';
import InlineEditableItemContainer from '~/components/forms/questions/components/InlineEditableItemContainer';

const InvoiceHeaderQuestion = ({ label, value, setValue, settings }: QuestionComponentProps) => {
    const business = useCurrentBusiness();
    const businessName = settings?.businessName || business?.name || '';
    const businessAddress = settings?.businessAddress || business?.physical_address || '';

    // Get invoice and client from context
    const invoiceContext = useInvoiceContext();
    const invoice = invoiceContext?.invoice;

    // Use invoice_number from invoice model, fallback to settings, then invoice ID, then 'TBD'
    const invoiceNumber = invoice?.invoice_number || settings?.invoiceNumber || invoice?.id || 'TBD';

    return (
        <div className="invoice-header flex flex-col sm:flex-row justify-between items-start gap-4">
            <InlineEditableItemContainer className="invoice-header__meta p-4 w-full sm:w-auto">
                {businessName && (
                    <div className="text-2xl font-bold text-gray-900">
                        {businessName}
                    </div>
                )}
                {businessAddress && (
                    <div className="text-gray-600 whitespace-pre-line">
                        {businessAddress}
                    </div>
                )}
                {!businessName && !businessAddress && (
                    <div className="text-gray-400 italic">
                        No business information configured
                    </div>
                )}
            </InlineEditableItemContainer>
            <div className="invoice-header__invoice justify-end w-full sm:w-auto">
                <InlineEditableItemContainer label="Invoice Number">
                    #{invoiceNumber}
                </InlineEditableItemContainer>
            </div>
        </div>
    );
};

export default InvoiceHeaderQuestion;

